import { useContext } from 'react';
import { LinkParamsContext } from '../../context/LinkParamsContext.';

const useLinkParams = () => useContext(LinkParamsContext);

export default useLinkParams;
